import { render, staticRenderFns } from "./DiscountSetting.vue?vue&type=template&id=ff7b8352&scoped=true"
import script from "./DiscountSetting.vue?vue&type=script&lang=js"
export * from "./DiscountSetting.vue?vue&type=script&lang=js"
import style0 from "./DiscountSetting.vue?vue&type=style&index=0&id=ff7b8352&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff7b8352",
  null
  
)

export default component.exports